function isYesterday(date: Date) {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return yesterday.toDateString() === date.toDateString();
}

export default (date?: string | Date) => {
  if (!date) {
    return {};
  }

  const isSameYear = new Date(date).getFullYear() === new Date().getFullYear();
  const isSameMonth = new Date(date).getMonth() === new Date().getMonth();
  const isSameDay = new Date(date).getDate() === new Date().getDate();
  const dateIsYesterday = isYesterday(new Date(date));

  return {
    isSameYear,
    isSameMonth,
    isSameDay,
    isYesterday: dateIsYesterday
  };
};
